import axiosInstance from './axiosConfig';

const API_URL = '/api/project';

const sendEnquiry = ({ projectState, totalCost, pdfBase64 }) => {
  return axiosInstance.post(`${API_URL}/send-enquiry`, {
    projectState,
    totalCost,
    pdfBase64, // Надсилаємо PDF на сервер
  });
};

const projectService = {
  sendEnquiry,
};

export default projectService;